import React from 'react'
import { Container, Button } from 'reactstrap';

import { mind_pattern_sections } from '../../../core/constants'

const ReadyPartTwo = (props) => {

  const { areas, hanndleNext } = props;

  return (
    <>
    <div className='w-100 h-100'>
    <Container fluid="md" className='mx-auto h-100 p-0'>
      <div className='py-md-3 px-md-3 rounded border-md h-100'>
        <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Mind Patterns</h1>
        <p className='mb-3'><strong>Thank you for answering the Mind Pattern questionnaire. You're almost done with the assessment, just a couple more steps!</strong></p>
        <p className='mb-3'>In the following section, read through each option and select the one that seems most true for you. Then, proceed to the next step.</p>
        <p className='mb-4'>Just answer each question as truthfully as possible without thinking too hard about them.</p>
        <div className='mind-pattern-report-user mb-4 px-xl-4 text-center'>
          {areas.items.map((area, index) => (
            <div key={index} className={`mind-pattern-area-report d-flex flex-column p-2 border rounded border-${area?.name.toLowerCase()}`}>
              <div className='mb-md-4 mb-2 mt-auto'><i className='mx-auto'><img src={area?.icon} alt={area?.name} width="100" height="100" className='d-block mx-auto' /></i></div>
              <p className="mb-auto h4-md font-weight-semibold text-capitalize">{area?.name}</p>
            </div>
          ))}
        </div>
        <div className='text-center'>
          <Button color='green-light' size='sm' onClick={ () => hanndleNext( mind_pattern_sections.ASSESSMENT_PART_TWO ) } className="mx-auto">
            <i className="bi bi-list-check mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" style={{marginBottom: '2px'}} width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19">
                    <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                </svg>
            </i>
            Next
            </Button>
        </div>
      </div>
    </Container>
    </div>
    </>
  )
}

export default ReadyPartTwo;
